export class DecimalUtils {
  // eslint-disable-next-line no-bitwise
  static toBinary = (v: number) => (v >>> 0).toString(2);
  static toDecimal = (binary: string) => Number.parseInt(binary, 2);
}
